$(function() {

    let price = $('.product__info-wrapper.grid__item .price-item.price-item--sale.price-item--last').text()
    $('span.price-item.price-item--regular').text(price);
    $('span#popUpPrice').text(price);


    $('.product-card-select__select.select.choices__input').on('change', function(e) {
        $('.product-form__input input[value*="'+e.currentTarget.value+'"]').click();
        addProdWishlist();
    })

    $('.product-card-select__select.select.choices__input').on('change', function(e) {
        setTimeout(function(){
            let price = $('.product__info-wrapper.grid__item .price-item.price-item--sale.price-item--last').text()
            $('span.price-item.price-item--regular').text(price);
            $('span#popUpPrice').text(price);
        }, 500);
    })

    $('.add-to-cart').click(function () {
        let price = $('.product__info-wrapper.grid__item .price-item.price-item--sale.price-item--last').text()
        let carr = this;
        let buttonPrice = $(carr).find('span.price-item.price-item--regular');
        buttonPrice.text(price);
        $('.product-form__submit.button.button--full-width.button--secondary').click()
        $('#product-price').text( $('.price__regular span.price-item.price-item--regular:first').text())
    })
    let errorMessage = document.querySelector('.product-form__error-message');

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            errorMessage.textContent =  window.cartStrings.outOfStock;
            $('.product-card-controls__item.product-card-controls__item--cart').append(errorMessage);
            observer.disconnect();
        });
    });
    var config = { attributes: true, childList: true, characterData: true };
    observer.observe(errorMessage, config);
})





